import "./SettingEmployeePanelsStyle.css";

import { AppBar, Toolbar, Typography } from "@mui/material";
import { EnhancedButtonPrimeReact, EnhancedButtonPrimeReactSeverity, IResponse, IServerError } from "@websential/cosmic-v20";
import React, { useEffect, useState } from "react";

import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { IAppState } from "../../../store/reducers";
import { PayrollService } from "../../../services/PayrollService";
import { useMutation } from "@tanstack/react-query";
import { useSelector } from "react-redux";

export interface IPayrollAdjustmentSettingEmployeeDataTable {
	rows: any;
	onSnackbarMessageData: (value: any) => void;
	onSaveAndCloseSettingEmployeeHandler: () => void;
	refetchGetAPI: () => void;
}
const HeaderColumns = [
	{
		field: "employeeName",
		headerName: "Employee",
		alignHeader: "center"
	},
	{
		field: "salaryProfileFields.default.value",
		fieldName: "salaryProfileFields",
		headerName: "Salary Profile",
		alignHeader: "center"
	},
	{
		field: "td1FederalFields.default.value",
		fieldName: "td1FederalFields",
		headerName: "TD1 Federal",
		alignHeader: "center"
	},
	{
		field: "td1Fields.default.value",
		fieldName: "td1Fields",
		headerName: "TD1",
		alignHeader: "center"
	},
	{
		field: "engineFields.default.value",
		fieldName: "engineFields",
		headerName: "Tax Engine",
		alignHeader: "center"
	}
];
export const PayrollAdjustmentSettingEmployeeDataTable: React.FC<IPayrollAdjustmentSettingEmployeeDataTable> = ({
	rows,
	onSnackbarMessageData,
	onSaveAndCloseSettingEmployeeHandler,
	refetchGetAPI
}) => {
	const clientId = useSelector((state: IAppState) => state.client.id)
	const [updatedItems, setUpdatedItems] = useState<any>(undefined);
	const [isSaveAndCloseButtonClicked, setIsSaveAndCloseButtonClicked] = useState<boolean>(false);
	// useEffect(() => {
	// 	if (rows && JSON.stringify(rows) !== JSON.stringify(updatedItems)) {
	// 		setUpdatedItems(rows);
	// 	}
	// }, [rows]);
	useEffect(() => {
		setUpdatedItems(rows);
	}, [rows]);

	// const onCellValueChange = (event: any, rowIndex: number, field: any) => {
	// 	setUpdatedItems((prev: any) => {
	// 		const updatedData = [...prev];
	// 		const updatedRow = { ...updatedData[rowIndex], [event.field]: field };
	// 		updatedData[rowIndex] = updatedRow;
	// 		return updatedData;
	// 	});
	// };
	const onCellValueChange = (fieldName: string, rowIndex: number, newValue: any, e: any) => {

		setUpdatedItems((prev: any) => {
			const updatedData = [...prev];
			const updatedRow = {
				...updatedData[rowIndex],
				[fieldName]: {
					...updatedData[rowIndex][fieldName],
					default: {
						...updatedData[rowIndex][fieldName].default,
						label: updatedData[rowIndex][fieldName].list?.find((item: any) => item.value === newValue)?.label,
						value: newValue,
					},
				},
			};
			updatedData[rowIndex] = updatedRow;
			return updatedData;
		});
	};
	const columnsBody = (rowData: any, row: any, x: any) => {
		// if (x.field !== "employeeName" && x.field !== "employeeId" && rowData[x.fieldName].tag) {

		// 	return (
		// 		<Dropdown
		// 			options={[{label:"sadvcav",value:"advav"}]}
		// 			value={rowData[x.field]}
		// 			onChange={(e: any) =>
		// 				onCellValueChange(x, row.rowIndex, e.target.value)
		// 			}
		// 			// onKeyDown={(e) => e.stopPropagation()}
		// 			// style={{ width: "100%" }}
		// 		/>
		// 	)
		// } else if (x.field !== "employeeName" && x.field !== "employeeId"  && !rowData[x.fieldName].tag) {
		// 	return (
		// 		<Typography sx={{ fontSize: ".875rem" }}>
		// 			{rowData[x.field].label}
		// 		</Typography>
		// 	)
		// } else if (x.field === "employeeName"){
		// 	return (
		// 		<Typography sx={{ fontSize: ".875rem" }}>
		// 			{rowData[x.field]}
		// 		</Typography>
		// 	)
		// }

		if (x.field === "employeeName") {
			return (
				<Typography sx={{ fontSize: ".875rem" }}>{rowData.employeeName}</Typography>
			);
		}

		const fieldData = rowData[x.fieldName]; // e.g. rowData["salaryProfileFields"]
		console.log(`Field: ${x.fieldName}`, fieldData);

		if (!fieldData) return null;

		if (fieldData.tag) {
			const currentValue = fieldData.default?.value;
			console.log("currentValuecurrentValue", currentValue)
			return (
				<Dropdown
					options={fieldData.list ?? []}
					
					value={currentValue}
					onChange={(e: any) =>
						onCellValueChange(x.fieldName, row.rowIndex, e.value, e)
					}
					className={"input-dropdown-fields"}
				// onKeyDown={(e) => e.stopPropagation()}
				// style={{ width: "100%" }}
				/>
			);
		} else {
			return (
				<Typography sx={{ fontSize: ".875rem" }}>
					{fieldData.default?.label}
				</Typography>
			);
		}
	};

	const {
		isPending: isSubmittingUpdatedRows,
		mutate: submitUpdatedRows,
	} = useMutation({
		mutationFn: PayrollService.submitPayrollAdjustmentFieldsData,
		onSuccess: (res: any | IServerError | IResponse) => {

			if (res.status === 200) {
				onSnackbarMessageData({
					open: true,
					message: "Success",
					severity: "success",
				});
				if (isSaveAndCloseButtonClicked) onSaveAndCloseSettingEmployeeHandler();
				if (!isSaveAndCloseButtonClicked) refetchGetAPI();
			} else {
				onSnackbarMessageData({
					open: true,
					message: res.message
						? res.message
						: "Something went wrong, try again later!",
					severity: "error",
				});
			}
		},
		onError: (err: any) => {
			onSnackbarMessageData({
				open: true,
				message: err.message,
				severity: "error",
			});
		},
	});

	const onSubmitButtonClickedHandler = () => {
		let currentRow = updatedItems[0]
		let payload = {
			clientId: clientId,
			employeeId: currentRow.employeeId,
			payPeriodEndDate: currentRow.payPeriodEndDate,
			payrollSheduleId: currentRow.payrollSheduleId,
			payrollEngineDate: currentRow.engineFields.default.value,
			td1Date: currentRow.td1Fields.default.value,
			td1FederalDate: currentRow.td1FederalFields.default.value,
			salaryProfileDate: currentRow.salaryProfileFields.default.value
		}
		submitUpdatedRows(payload);
	}
	const onSubmitAndCloseButtonClickedHandler = () => {
		setIsSaveAndCloseButtonClicked(true)
		let currentRow = updatedItems[0]
		let payload = {
			clientId: clientId,
			employeeId: currentRow.employeeId,
			payPeriodEndDate: currentRow.payPeriodEndDate,
			payrollSheduleId: currentRow.payrollSheduleId,
			payrollEngineDate: currentRow.engineFields.default.value,
			td1Date: currentRow.td1Fields.default.value,
			td1FederalDate: currentRow.td1FederalFields.default.value,
			salaryProfileDate: currentRow.salaryProfileFields.default.value
		}
		submitUpdatedRows(payload);
	}

	const footer = () => {
		return (
			<AppBar
				position="sticky"
				color="default"
				elevation={1}
				sx={{
					// backgroundColor: "#fff",
					backgroundColor: "#F7F7F7",
					// marginTop: theme.spacing(3),
					boxShadow: "none",
					alignItems: "center",
					zIndex: 0,
					position: "sticky",
					bottom: 0,
				}}
			>
				<Toolbar>
					<EnhancedButtonPrimeReact
						label="Save"
						loading={!isSaveAndCloseButtonClicked && isSubmittingUpdatedRows}
						onClickHandler={onSubmitButtonClickedHandler}
						raised
						severity={EnhancedButtonPrimeReactSeverity.Success}
					/>
					<EnhancedButtonPrimeReact
						label="Save & Close"
						loading={isSaveAndCloseButtonClicked}
						onClickHandler={onSubmitAndCloseButtonClickedHandler}
						raised
						severity={EnhancedButtonPrimeReactSeverity.Secondary}
						style={{ marginLeft: "1rem" }}
					/>
				</Toolbar>
			</AppBar>
		)
	}

	return (
		<div>
			<DataTable
				value={rows && updatedItems}
				dataKey="employeeId"
				emptyMessage={rows && rows.length === 0 ? "No Employee(s) found." : "Loading..."}
				className="SettingEmployeePanelsStyle"
				footer={footer}
				key={JSON.stringify(updatedItems)}
			>
				{/* <Column
					selectionMode="multiple"
					style={{ width: "36px", textAlign: "center" }}
					field="selection"
					columnKey="selection"
				></Column> */}
				{HeaderColumns.map((x: any, index: any) => {
					return <Column
						key={index}
						field={x.field}
						header={x.headerName}
						alignHeader={x.alignHeader}
						style={{ fontSize: ".875rem" }}
						body={(rowData: any, row: any) =>
							columnsBody(rowData, row, x)
						}
					/>;
				})}
			</DataTable>
		</div>
	);
};
